import BaseComponent from "../../../baseComponent";
import Expression from "./expression.jsx";
import MinMax from "./minMax.jsx";
import ChartType from "./chartType.jsx";
import Label from "./label.jsx";
import YAxisSide from "./yAxisSide.jsx";
import Color from "./color.jsx";
import Opacity from "./opacity.jsx";
import Actions from "./actions.jsx";
import Toggle from "./toggle.jsx";
import StokeWidth from "./strokeWidth.jsx";
import CustomColor from "./customColor.jsx";
import styles from "./styles.scss";



export default class TimeSeriesConfig extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const errors = this.props.legend.errors;
    const p = this.props.legend.parameters;
    let firstDataset, secondDataset, secondLabel, filter, minMax, firstLabel = "Data", step, strokeWidth, showDiff,
      tailPoint;

    const stepConfig = <Toggle field="stepChart" value={p.chartTypeParameters.stepChart}
                               label="Step Chart"
                               isChartTypeParameters={true}
                               onLegendChange={this.props.onLegendChange}/>;
    const strokeWidthConfig = <StokeWidth strokeWidth={p.chartTypeParameters.strokeWidth}
                                          onLegendChange={this.props.onLegendChange}/>;
    switch (p.chartType) {
      case "line": {
        step = stepConfig;
        strokeWidth = strokeWidthConfig;
        break;
      }
      case "range": {
        firstLabel = "First Data";
        secondDataset = this.props.isStudioWidget ? null : <Expression label="Second Data"
                                                                       expressionKey="y"
                                                                       widgetId={this.props.widgetId}
                                                                       legendId={this.props.legend.id}
                                                                       onLegendChange={this.props.onSecondaryLegendChange}
                                                                       expression={this.props.secondarylegend.expressions.y}
                                                                       dashboardVariables={this.props.dashboardVariables}
                                                                       mappings={this.props.secondarylegend.mappings}/>;

        secondLabel = <Label text="Second Label" label={this.props.secondarylegend.parameters.legendLabel}
                             onLegendChange={this.props.onSecondaryLegendChange}/>;
        step = stepConfig;
        strokeWidth = strokeWidthConfig;
        showDiff = <Toggle field="showDifference" value={p.showDifference === undefined ? true : p.showDifference}
                           label="Show difference"
                           onLegendChange={this.props.onLegendChange}/>;
        break;
      }
      case "bubble": {
        firstLabel = "Y-axis Data";
        secondDataset = this.props.isStudioWidget ? null : <Expression label="Volume"
                                                                       expressionKey="size"
                                                                       widgetId={this.props.widgetId}
                                                                       legendId={this.props.legend.id}
                                                                       onLegendChange={this.props.onLegendChange}
                                                                       expression={this.props.legend.expressions.size}
                                                                       dashboardVariables={this.props.dashboardVariables}
                                                                       mappings={this.props.legend.mappings}/>;
        filter = <Expression label="Filter"
                             expressionKey="filter"
                             widgetId={this.props.widgetId}
                             legendId={this.props.legend.id}
                             onLegendChange={this.props.onLegendChange}
                             expression={this.props.legend.expressions.filter}
                             dashboardVariables={this.props.dashboardVariables}
                             mappings={this.props.legend.mappings}/>;

        tailPoint = <Expression label="TailPoint"
                                expressionKey="tailPoint"
                                widgetId={this.props.widgetId}
                                legendId={this.props.legend.id}
                                onLegendChange={this.props.onLegendChange}
                                expression={this.props.legend.expressions.tailPoint}
                                dashboardVariables={this.props.dashboardVariables}
                                mappings={this.props.legend.mappings}/>;

        minMax = <MinMax label="Volume Min/Max"
                         min={p.chartTypeParameters.min}
                         max={p.chartTypeParameters.max}
                         onLegendChange={this.props.onLegendChange}/>;
        break;
      }
    }

    firstDataset = this.props.isStudioWidget ? null : <Expression label={firstLabel}
                                                                  expressionKey="y"
                                                                  widgetId={this.props.widgetId}
                                                                  legendId={this.props.legend.id}
                                                                  error={this.props.legend.errors.y}
                                                                  onLegendChange={this.props.onLegendChange}
                                                                  expression={this.props.legend.expressions.y}
                                                                  dashboardVariables={this.props.dashboardVariables}
                                                                  mappings={this.props.legend.mappings}/>;


    return (

      <div className={styles.legendConfig} name="legendConfig" style={this.props.configStyle}>
        <div className={styles.legendConfigContent}>
          <Actions closeLegendConfig={this.props.closeLegendConfig} copyLegend={this.props.copyLegend}/>
          <Label label={p.legendLabel}
                 onLegendChange={this.props.onLegendChange}/>
          {secondLabel}
          <ChartType chartType={p.chartType}
                     onLegendChange={this.props.onLegendChange}/>
          {firstDataset}
          {secondDataset}
          {minMax}
          {filter}
          {tailPoint}
          <YAxisSide side={p.yAxisSide}
                     onLegendChange={this.props.onLegendChange}/>
          <Color color={p.legendColor}
                 onLegendChange={this.props.onLegendChange}/>
          <CustomColor color={p.legendColor}
                       onLegendChange={this.props.onLegendChange}/>
          {strokeWidth}
          <Opacity chartType={p.chartType}
                   opacity={p.chartTypeParameters}
                   onLegendChange={this.props.onLegendChange}/>

          <div className={styles.toggles}>
            {step}
            {showDiff}
            <Toggle field="legendVisible" value={p.legendVisible === undefined ? true : p.legendVisible}
                    label="Legend Visible"
                    onLegendChange={this.props.onLegendChange}/>
            <Toggle field="dataVisible" value={p.dataVisible === undefined ? true : p.dataVisible} label="Data Visible"
                    onLegendChange={this.props.onLegendChange}/>
            <Toggle field="tooltipVisible" value={p.tooltipVisible === undefined ? true : p.tooltipVisible}
                    label="Tooltip Visible"
                    onLegendChange={this.props.onLegendChange}/>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/timeSeriesConfig.jsx